"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPriceOrFormula = formatPriceOrFormula;
const format_1 = require("../format");
function formatNumber(value) {
    if (value === null)
        return null;
    const n = Number(value);
    if (Number.isNaN(n))
        return null;
    return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
// payable_percent is stored either as a fraction (0.95) or a percentage (95)
// across cutover-era rows; the >1.5 heuristic disambiguates.
function formatPercent(value) {
    if (value === null)
        return null;
    const n = Number(value);
    if (Number.isNaN(n))
        return null;
    return (0, format_1.formatPercentValue)(n > 1.5 ? n : n * 100);
}
function formatSignedNumber(value) {
    if (value === null)
        return null;
    const n = Number(value);
    if (Number.isNaN(n))
        return null;
    const formatted = Math.abs(n).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return n >= 0 ? `+${formatted}` : `−${formatted}`;
}
function formatFixed(ticket) {
    const price = formatNumber(ticket.signedPrice);
    if (price === null)
        return '—';
    return ticket.currency === null ? price : `${price} ${ticket.currency}`;
}
function formatFormula(ticket, basisLabel) {
    const payable = formatPercent(ticket.payablePercent) ?? '—';
    return `${basisLabel} × ${payable}`;
}
function formatIndex(ticket, basisLabel) {
    const premium = formatSignedNumber(ticket.premiumDiscount);
    return premium === null ? basisLabel : `${basisLabel} ${premium}`;
}
function formatPriceOrFormula(ticket) {
    if (ticket?.pricingType == null)
        return '—';
    const basisLabel = ticket.basis ?? ticket.referencePriceSource ?? 'LME';
    if (ticket.pricingType === 'Fixed')
        return formatFixed(ticket);
    if (ticket.pricingType === 'Formula')
        return formatFormula(ticket, basisLabel);
    if (ticket.pricingType === 'Index')
        return formatIndex(ticket, basisLabel);
    return ticket.pricingType;
}
//# sourceMappingURL=price-formula.js.map